import { ForwardedRef, forwardRef, useEffect, useRef, useState } from "react";

type IRadio = {
  name: string;
  id: string;
  label: string;
  defaultChecked: boolean;
};
const Radio = (
  { id, name, defaultChecked, label }: IRadio,
  ref: ForwardedRef<HTMLInputElement>
) => {
  const radioRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (defaultChecked && radioRef.current) {
      radioRef.current.checked = defaultChecked;
    }
  }, [defaultChecked]);

  return (
    <>
      <input type="radio" ref={radioRef} id={id} name={name} />
      <label
        htmlFor={id}
        onClick={(e) => {
          const prev = e.currentTarget.previousSibling as HTMLInputElement;
          prev.setAttribute("data-type", "U");
        }}
      >
        {label}
      </label>
    </>
  );
};

export default forwardRef<HTMLInputElement, IRadio>(Radio);
